if (!customElements.get('candymix-popular-tabs')) {
  class CandyMixPopularTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = this.querySelector('.cm-popular-tabs__panels');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
    }

    activate(tab) {
      const tabId = tab.dataset.tabId;
      let panel = this.panels.querySelector(`[data-panel-id="${tabId}"]`);

      if (!panel) {
        const template = this.querySelector(`template[data-panel-template="${tabId}"]`);
        if (template) {
          this.panels.append(template.content.cloneNode(true));
          panel = this.panels.querySelector(`[data-panel-id="${tabId}"]`);
        }
      }

      if (!panel) return;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });

      this.panels.querySelectorAll('[role="tabpanel"]').forEach((item) => {
        item.hidden = item !== panel;
      });
    }

    handleKeydown(event, index) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

      event.preventDefault();
      let nextIndex = index;

      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      this.tabs[nextIndex].focus();
      this.activate(this.tabs[nextIndex]);
    }
  }

  customElements.define('candymix-popular-tabs', CandyMixPopularTabs);
}
